/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";
import "twin.macro";

export const Empty = ({ children }) => {
  const { t } = useTranslation();
  return <span tw="text-gray-300">{children || t("shared.empty")}</span>;
};
